import zex from '../modules/zex.js'
export default [
    // 分享页面
    {path: '/zex/shareFinance.xhtml',name:'shareFinance', component:zex.shareFinance,meta:{title:"政采信"}},
    // 融资申请页面
	{path: '/zex/financeApply.xhtml',name:'financeApply', component:zex.financeApply},
    // 二维码
	{path: '/zex/shareCode.xhtml',name:'shareCode', component:zex.shareCode,meta:{title:"政采信"}},
] 